import { useMemo } from 'react';
import fireIcon from '../../assets/WidgetsIcon/fire.svg';
import rescueIcon from '../../assets/WidgetsIcon/rescue.svg';
import oIcon from '../../assets/WidgetsIcon/O.svg';
import emsIcon from '../../assets/WidgetsIcon/ems.svg';
import hazmatIcon from '../../assets/WidgetsIcon/hazmat.svg';
import graphIcon from '../../assets/WidgetsIcon/graph-icon.svg';
import carIcon from '../../assets/WidgetsIcon/car.svg';
import ava from '../../assets/WidgetsIcon/ava.svg';


export const calculatePercentages = (data) => {
  const total = Object.values(data).reduce((sum, value) => sum + value, 0);

  if (total === 0) {
    return Object.fromEntries(Object.keys(data).map((key) => [key, '0.00%']));
  }

  return Object.fromEntries(
    Object.entries(data).map(([key, value]) => [
      key,
      ((value / total) * 100).toFixed(0) + '%',
    ])
  );
};

export const typeIconMatching = (type) => {
  switch (type) {
    case 'Fire':
      return fireIcon;

    case 'Hazsit':
      return hazmatIcon;

    case 'Medical':
      return emsIcon;

    case 'Noemerg':
      return oIcon;

    case 'Rescue':
      return rescueIcon;
    default:
      return oIcon;
  }
};
